import { useQueryClient } from "@tanstack/react-query";
import { Dispatch, SetStateAction, useState } from "react";

import { uploadMedia } from "../../core/media.core";
import { useTranslation } from "../../core/translation.core";

export enum MediaSelectorMode {
  multiple,
  single,
}

interface UploadMediaProps {
  selectorMode: MediaSelectorMode;
  setMediaIds: Dispatch<SetStateAction<string[]>>;
  toggleSelected: (mediaId: string, isSelected: boolean) => void;
}

export default function DirectUploadMediaForm({ selectorMode, setMediaIds, toggleSelected }: UploadMediaProps) {
  const { t, msg } = useTranslation();
  const [uploadingStatus, setUploadingStatus] = useState(t(msg.media.addN));
  const [mediaValue, setMediaValue] = useState();
  const queryClient = useQueryClient();

  const handleMediaUpload = async (e) => {
    const { files } = e.target;
    if (files.length < 1) {
      return;
    }

    setUploadingStatus(t(msg.form.uploading));
    const mediaData = await uploadMedia(files, queryClient);
    setUploadingStatus(t(msg.media.addN));
    const ids = mediaData.map((m) => m.media.id);

    // replace old media if in single mode or add to array
    if (selectorMode === MediaSelectorMode.single) {
      setMediaIds(ids);
    } else {
      setMediaIds((prev) => [...prev, ...ids]);
    }

    //add to selected
    ids.forEach((i) => {
      toggleSelected(i, true);
    });

    queryClient.invalidateQueries({ queryKey: ["mediaList"] });
  };

  return (
    <label className="cursor-pointer block mb-4 text-blue-400" id="direct-media-upload">
      <span>{uploadingStatus}</span>
      <input type="file" name="media" multiple className="opacity-0" value={mediaValue} onChange={handleMediaUpload} />
    </label>
  );
}

 